/* 3D 독립 재계산. 장면의 좌표에서 길이, 넓이, 부피, 각을 다시 구해 엔진이 잰 값과 맞추는 데 쓴다 */
export type V3 = [number, number, number];

const sub = (a: V3, b: V3): V3 => [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
const dot = (a: V3, b: V3): number => a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const cross = (a: V3, b: V3): V3 => [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
const norm = (a: V3): number => Math.sqrt(dot(a, a));

export const distance3 = (a: V3, b: V3): number => norm(sub(a, b));

/** 한 평면 위의 다각형 넓이. 꼭짓점을 순서대로 준다 */
export function polygonArea3(points: V3[]): number {
  let n: V3 = [0, 0, 0];
  points.forEach((p, i) => { const c = cross(p, points[(i + 1) % points.length]); n = [n[0] + c[0], n[1] + c[1], n[2] + c[2]]; });
  return norm(n) / 2;
}

/** 밑면 다각형과 꼭짓점의 각뿔 부피 */
export function pyramidVolume3(base: V3[], apex: V3): number {
  let n: V3 = [0, 0, 0];
  base.forEach((p, i) => { const c = cross(p, base[(i + 1) % base.length]); n = [n[0] + c[0], n[1] + c[1], n[2] + c[2]]; });
  return Math.abs(dot(n, sub(apex, base[0]))) / 6;
}

/** 꼭짓점 vertex 에서 a 와 c 가 이루는 각, 도 단위 */
export function angleDegrees3(a: V3, vertex: V3, c: V3): number {
  const u = sub(a, vertex); const v = sub(c, vertex);
  return (Math.acos(Math.max(-1, Math.min(1, dot(u, v) / (norm(u) * norm(v))))) * 180) / Math.PI;
}

/** 점에서 세 점이 정하는 평면까지의 거리 */
export function pointPlaneDistance3(p: V3, a: V3, b: V3, c: V3): number {
  const n = cross(sub(b, a), sub(c, a));
  return Math.abs(dot(n, sub(p, a))) / norm(n);
}
